<template>
  <click-to-edit
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.min')"
    v-model="scope.row.scale.min"
    @input="saveElementPropChange(scope.row, 'scale', {min:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-configurable-scale-min-table-column',
  mixins: [ElementPropTableColumn],
  components: {ClickToEdit},

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {}
}

</script>

<style>

</style>
